<template>

    <main class="player" @mousemove="mouseMove" ref="wrapper" :class="{ inactive : !activeInterface }">
    <!-- <main class="player" ref="wrapper" :class="{ inactive : !activeInterface }"> -->

        <!-- <div class="pic cvr" style="background-image:url('/img/preview/mad.jpg')"></div> -->

        <div class="vid-container" @click.prevent="pictureClick">
            <video width="1680" height="944" playsinline autoplay ref="player">
                <source type="video/mp4" :src="videoURL">
            </video>
        </div>

        <router-link to="/preview" class="p-btn x" :class="{ inactive : !activeInterface }">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M19.4706 2.5L2.5 19.4706" stroke="white" stroke-width="3" stroke-linecap="square"/>
            <path d="M19.4706 19.4706L2.5 2.5" stroke="white" stroke-width="3" stroke-linecap="square"/>
            </svg>
        </router-link>

        <div class="btm" :class="{ inactive : !activeInterface }" @mouseenter="mouseIn" @mouseleave="mouseOut">

            <div class="container n-mx">

                <div class="timeline-info">
                    <div class="current">
                        <span class="ft-bld">{{ currentTime || "00:00" }}</span>
                    </div>
                    <div class="timeline">
                        <slider
                            :handles="[0]"
                            :connect="[true,false]"
                            :range = "{ 
                                'min': 0, 
                                'max': 1 
                            }"
                            :set="setValueTime"
                            @start="sliderStartTime"
                            @change="sliderChangeTime"
                            @end="sliderEndTime"
                        >
                        </slider>
                    </div>
                    <div class="remaining">
                        <span class="ft-bld">{{ totalTime || "00:00" }}</span>
                    </div>
                </div>

                <div class="actns">
                    <div class="lft">
                        <div class="col txt-info">
                            <span class="ft-xbld name" :style="{ color : Global.mockupConfig.colors.icons }">
                                {{ asset.name }}
                            </span>
                        </div>
                    </div>
                    <div class="ctr">
                        <div class="fast bwd" @click.prevent="goBw" :class="{ mve : quickBw }">
                            <svg width="32" height="32" viewBox="0 0 38 38" fill="none">
                                <g><path d="M19 6.00002C26.732 6.00002 33 12.268 33 20C33 27.732 26.732 34 19 34C11.268 34 5.00002 27.732 5.00002 20C5.00002 16.134 6.56702 12.634 9.10052 10.1005C9.42449 9.77656 9.76425 9.4684 10.1186 9.17729" :stroke="Global.mockupConfig.colors.icons" stroke-width="2.5" stroke-linecap="round"/>
                                <path d="M21.25 1.69672L16.9467 6.00002L21.25 10.3033" :stroke="Global.mockupConfig.colors.icons" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></g>
                                <path d="M15.0423 24.75V18.432L13.5863 19.407L12.4943 17.704L15.4453 15.767H17.4343V24.75H15.0423ZM21.8656 24.984C20.713 24.984 19.855 24.5983 19.2916 23.827C18.737 23.047 18.4596 21.864 18.4596 20.278C18.4596 17.106 19.621 15.52 21.9436 15.52C23.0963 15.52 23.95 15.91 24.5046 16.69C25.068 17.4613 25.3496 18.64 25.3496 20.226C25.3496 23.398 24.1883 24.984 21.8656 24.984ZM21.9046 22.943C22.156 22.943 22.351 22.8607 22.4896 22.696C22.637 22.5313 22.7453 22.2583 22.8146 21.877C22.884 21.487 22.9186 20.9453 22.9186 20.252C22.9186 19.5933 22.8883 19.069 22.8276 18.679C22.767 18.289 22.663 18.0073 22.5156 17.834C22.3683 17.652 22.1646 17.561 21.9046 17.561C21.6533 17.561 21.454 17.6433 21.3066 17.808C21.168 17.9727 21.064 18.25 20.9946 18.64C20.9253 19.0213 20.8906 19.5587 20.8906 20.252C20.8906 20.9107 20.921 21.435 20.9816 21.825C21.0423 22.215 21.1463 22.501 21.2936 22.683C21.441 22.8563 21.6446 22.943 21.9046 22.943Z" fill="white"/>
                            </svg>
                        </div>
                        <div class="play" @click.prevent="togglePlayState" :class="{ paused : isPlaying }" :style="{ background : Global.mockupConfig.colors.icons }">

                            <span class="a">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.39878C0 1.6322 3.05843 -0.0407015 5.38799 1.45166L18.8143 10.0529C20.9637 11.4298 20.9637 14.5702 18.8143 15.9471L5.38799 24.5483C3.05843 26.0407 0 24.3678 0 21.6012V4.39878Z" fill="black"/>
                                </svg>
                            </span>
                            <span class="b">
                                <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
                                    <path d="M5.88234 23.1765H1.17647C0.526723 23.1765 0 22.6497 0 22V2.00001C0 1.35027 0.526723 0.823545 1.17647 0.823545H5.88234C6.53209 0.823545 7.05881 1.35027 7.05881 2.00001V22C7.05881 22.6497 6.53209 23.1765 5.88234 23.1765Z" fill="black"/>
                                    <path d="M18.8235 23.1765H14.1176C13.4679 23.1765 12.9412 22.6497 12.9412 22V2.00001C12.9412 1.35027 13.4679 0.823545 14.1176 0.823545H18.8235C19.4733 0.823545 20 1.35027 20 2.00001V22C20 22.6497 19.4733 23.1765 18.8235 23.1765Z" fill="black"/>
                                </svg>
                            </span>

                        </div>
                        <div class="fast fwd" @click.prevent="goFw" :class="{ mve : quickFw }">
                            <svg width="32" height="32" viewBox="0 0 38 38" fill="none">
                                <g><path d="M19 6.00002C11.268 6.00002 5 12.268 5 20C5 27.732 11.268 34 19 34C26.732 34 33 27.732 33 20C33 16.134 31.433 12.634 28.8995 10.1005C28.5755 9.77656 28.2358 9.4684 27.8814 9.17729" :stroke="Global.mockupConfig.colors.icons" stroke-width="2.5" stroke-linecap="round"/>
                                <path d="M16.75 1.69672L21.0533 6.00002L16.75 10.3033" :stroke="Global.mockupConfig.colors.icons" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></g>
                                <path d="M15.0423 24.75V18.432L13.5863 19.407L12.4943 17.704L15.4453 15.767H17.4343V24.75H15.0423ZM21.8656 24.984C20.713 24.984 19.855 24.5983 19.2916 23.827C18.737 23.047 18.4596 21.864 18.4596 20.278C18.4596 17.106 19.621 15.52 21.9436 15.52C23.0963 15.52 23.95 15.91 24.5046 16.69C25.068 17.4613 25.3496 18.64 25.3496 20.226C25.3496 23.398 24.1883 24.984 21.8656 24.984ZM21.9046 22.943C22.156 22.943 22.351 22.8607 22.4896 22.696C22.637 22.5313 22.7453 22.2583 22.8146 21.877C22.884 21.487 22.9186 20.9453 22.9186 20.252C22.9186 19.5933 22.8883 19.069 22.8276 18.679C22.767 18.289 22.663 18.0073 22.5156 17.834C22.3683 17.652 22.1646 17.561 21.9046 17.561C21.6533 17.561 21.454 17.6433 21.3066 17.808C21.168 17.9727 21.064 18.25 20.9946 18.64C20.9253 19.0213 20.8906 19.5587 20.8906 20.252C20.8906 20.9107 20.921 21.435 20.9816 21.825C21.0423 22.215 21.1463 22.501 21.2936 22.683C21.441 22.8563 21.6446 22.943 21.9046 22.943Z" fill="white"/>
                            </svg>
                        </div>
                    </div>
                    <div class="rgt">
                        <div class="vol-outer" @mouseleave="leaveVol" :class="{ active : activeVolBar }">
                            <slider
                                :handles="[1]"
                                :connect="[true,false]"
                                :range = "{ 
                                    'min': 0, 
                                    'max': 1 
                                }"
                                :set="setCurrentVol"
                                @update="sliderChangeVol"
                                @end="sliderEndVol"
                            >
                            </slider>
                            <div class="p-btn vol" @click.prevent="toggleMute" @mouseenter="enterVol">
                                <svg width="35" height="23" viewBox="0 0 35 23" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 6.91867H3.33333C2.59733 6.91867 2 7.516 2 8.252V14.5853C2 15.3213 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4133C12.672 21.148 14 20.532 14 19.396V3.44133C14 2.30533 12.6707 1.68933 11.8053 2.424L6.5 6.91867Z" fill="white" stroke="white" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M19.3827 16.7227C20.932 15.76 22 13.7573 22 11.4253C22 9.09333 20.932 7.08933 19.3827 6.11467" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :class="{ hde : currentVol == 0 }"/>
                                <path d="M23.34 20.8387C25.7507 18.7653 27.3333 15.3253 27.3333 11.4227C27.3333 7.51467 25.748 4.072 23.3333 2" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :class="{ hde : currentVol < .5 }"/>
                                <rect width="3" height="15" rx="1.5" transform="matrix(0.707103 0.70711 -0.707103 0.70711 27.8491 5.24249)" fill="white" :class="{ shw : currentVol == 0 }"/>
                                <rect width="3" height="15" rx="1.5" transform="matrix(0.707107 -0.707107 0.707114 0.7071 17.2427 7.36389)" fill="white" :class="{ shw : currentVol == 0 }"/>
                                </svg>

                            </div>
                        </div>
                        <div class="p-btn fs" @click.prevent="toggleFs" :class="{ active : isFs }">
                            <svg width="26px" height="26px" viewBox="0 0 26 26">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                                    <g transform="translate(2.000000, 2.000000)" stroke="#FFFFFF" stroke-width="3">
                                        <g class="g-arw top"><polyline transform="translate(18.250000, 3.750000) rotate(-270.000000) translate(-18.250000, -3.750000) " points="14.5 7.5 14.5 -9.09494702e-13 22 -9.09494702e-13"></polyline>
                                        <line x1="21.5" y1="0.5" x2="13.5" y2="8.5"></line></g>
                                        <g class="g-arw bot"><line x1="8.5" y1="13.5" x2="0.5" y2="21.5"></line>
                                        <polyline transform="translate(3.750000, 18.250000) rotate(-90.000000) translate(-3.750000, -18.250000) " points="-2.13162821e-13 22 0 14.5 7.5 14.5"></polyline></g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="more"></div>

            </div>
            
        </div>

    </main>

</template>

<script>

    import Global from '../../lib/GlobalState'

    export default {

        name: 'Player',

        data() {
            return {
                Global,
                btmHovered: false,
                interval: '',
                activeInterface: true,
                totalTime: 0,
                currentTime: null,
                isFs: false,
                quickFw: false,
                quickBw: false,
                isGrabbed: false,
                setValueTime: 0,
                isPlaying: true,
                activeVolBar: false,
                currentVol: 1,
                setCurrentVol: 1,
                lastVol: 1,
                videoURL: null
            }
        },

        computed: {
            asset() {
                if(this.Global.assets[this.Global.assetIndexToPlay] == undefined) {
                    return {}
                }
                
                return this.Global.assets[this.Global.assetIndexToPlay]
            }
        },

        mounted() {
            this.videoURL = this.asset.video
            this.init()
            // this.$refs.player.currentTime = 50
        },

        methods: {

            init() {
                this.listenersInit()
            },
            
            listenersInit() {
                document.addEventListener('fullscreenchange', this.exitHandler, false);
                document.addEventListener('mozfullscreenchange', this.exitHandler, false);
                document.addEventListener('MSFullscreenChange', this.exitHandler, false);
                document.addEventListener('webkitfullscreenchange', this.exitHandler, false);
                this.$refs.player.addEventListener('loadedmetadata', this.durationInit, false);
                this.$refs.player.addEventListener('timeupdate', this.durationUpdate, false);
                window.addEventListener('keyup', this.handleKeyDown, false);
            },

            formatTime(time) {
                var minutes = Math.floor(time / 60);
                var seconds = Math.round(time - (minutes * 60));

                if (minutes < 10) { minutes = "0" + minutes }
                if (seconds < 10) { seconds = "0" + seconds }
                return minutes + ":" + seconds
            },

            durationInit() {
                this.totalTime = this.formatTime(this.$refs.player.duration)
                this.$refs.player.volume = 1
            },

            durationUpdate() {
                this.currentTime = this.formatTime(this.$refs.player.currentTime)
                if (this.isGrabbed) return
                this.setValueTime = this.$refs.player.currentTime / this.$refs.player.duration
            },

            goBw() {
                this.$refs.player.currentTime = this.$refs.player.currentTime - 5
                this.quickBw = true
                setTimeout(() => { this.quickBw = false }, 150)
            },

            goFw() {
                this.$refs.player.currentTime = this.$refs.player.currentTime + 5
                this.quickFw = true
                setTimeout(() => { this.quickFw = false }, 150)
            },

            pictureClick(event) {
                if (event.detail === 1)
                    this.togglePlayState()
                else if (event.detail === 2)
                    this.toggleFs()
            },

            togglePlayState() {
                if(this.$refs.player.paused){
                    this.$refs.player.play()
                    this.isPlaying = true
                }else{
                    this.$refs.player.pause()
                    this.isPlaying = false
                }
            },

            toggleFs() {
                if (!this.isFs) this.goFullScreen()
                else this.exitFullScreen()
            },

            goFullScreen() {
                if (document.documentElement.requestFullscreen)
                    document.documentElement.requestFullscreen()
                else if (document.documentElement.webkitRequestFullscreen)
                    document.documentElement.webkitRequestFullscreen()
                else if (document.documentElement.msRequestFullscreen)
                    document.documentElement.msRequestFullscreen()
                this.isFs = true
            },

            exitFullScreen() {
                if (document.exitFullscreen)
                    document.exitFullscreen()
                else if (document.webkitExitFullscreen)
                    document.webkitExitFullscreen()
                else if (document.msExitFullscreen)
                    document.msExitFullscreen()
                this.isFs = false
            },

            exitHandler() {
                if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement)
                    this.isFs = false
            },

            toggleMute() {
                if(this.$refs.player.muted){
                    this.currentVol = this.setCurrentVol = this.lastVol
                    this.$refs.player.muted = false
                }
                else{
                    this.lastVol = this.currentVol
                    this.currentVol = this.setCurrentVol = 0
                    this.$refs.player.muted = true
                }
            },

            sliderStartTime() {
                this.isGrabbed = true
            },
            
            sliderEndTime() {
                this.isGrabbed = false
            },

            sliderChangeTime(event) {
                let cleanVal = parseFloat(event.values[0])
                let newPos = this.$refs.player.duration * cleanVal
                this.$refs.player.currentTime = newPos
            },

            mouseIn() {
                this.btmHovered = true
            },

            mouseOut() {
                this.btmHovered = false
            },

            mouseMove() {
                if (!this.activeInterface)
                    this.activeInterface = true
                clearInterval(this.interval)
                this.interval = setInterval(function() {
                    if (!this.activeInterface || this.btmHovered) return
                    this.activeInterface = false
                }.bind(this), 2000);
            },

            handleKeyDown(event) {
                if (event.key == ' ' || event.code == 'space' || event.keyCode == 32)
                    this.togglePlayState()
                if (event.key == 'ArrowRight' || event.code == 'ArrowRight' || event.keyCode == 39)
                    this.goFw()
                if (event.key == 'ArrowLeft' || event.code == 'ArrowLeft' || event.keyCode == 37)
                    this.goBw()
                if (event.key == 'ArrowUp' || event.code == 'ArrowUp' || event.keyCode == 38)
                    this.volUp()
                if (event.key == 'ArrowDown' || event.code == 'ArrowDown' || event.keyCode == 40)
                    this.volDwn()
                if (event.key == 'f' || event.code == 'KeyF' || event.keyCode == 70)
                    this.toggleFs()
                if (event.key == 'Escape' || event.code == 'Escape' || event.keyCode == 27){
                    if (this.isFs)
                        this.exitFullScreen()
                    else
                        this.$router.push('/preview').catch(()=>{});
                }
            },

            enterVol() {
                this.activeVolBar = true
            },

            leaveVol() {
                this.activeVolBar = false
            },

            sliderChangeVol(event) {
                let cleanVal = parseFloat(event.values[0])
                this.currentVol = cleanVal
                this.$refs.player.volume = this.currentVol
                if(!this.$refs.player.muted && cleanVal == 0){
                    this.$refs.player.muted = true
                    this.setCurrentVol = this.currentVol
                }
                if(this.$refs.player.muted && cleanVal > 0){
                    this.$refs.player.muted = false
                    this.setCurrentVol = this.currentVol
                }
            },

            sliderEndVol(event) {
                let cleanVal = parseFloat(event.values[0])
                this.currentVol = this.setCurrentVol = cleanVal
            },

            volUp() {
                if(this.currentVol == 1) return
                if((this.currentVol + .1) >= 1)
                    this.currentVol = this.setCurrentVol = 1
                else
                    this.currentVol = this.setCurrentVol = this.currentVol + .1
                this.$refs.player.volume = this.currentVol
            },

            volDwn() {
                if(this.currentVol == 0) return
                if((this.currentVol - .1) <= 0)
                    this.currentVol = this.setCurrentVol = 0
                else
                    this.currentVol = this.setCurrentVol = this.currentVol - .1
                this.$refs.player.volume = this.currentVol
            },

        },

        beforeDestroy() {
            document.removeEventListener('fullscreenchange', this.exitHandler, false);
            document.removeEventListener('mozfullscreenchange', this.exitHandler, false);
            document.removeEventListener('MSFullscreenChange', this.exitHandler, false);
            document.removeEventListener('webkitfullscreenchange', this.exitHandler, false);
            this.$refs.player.removeEventListener('loadedmetadata', this.durationInit, false);
            this.$refs.player.removeEventListener('timeupdate', this.durationUpdate, false);
            window.removeEventListener('keyup', this.handleKeyDown, false);
        }

    }

</script>